import api from "../../services/api";

class QueueCache {
    constructor() {
        this.data = null;
        this.lastFetchTime = 0;
        this.isLoading = false;
        this.pendingPromise = null;
        this.CACHE_DURATION = 60000; // 60 segundos
    }

    async getData() {
        const now = Date.now();

        if (this.isValidCache(now)) {
            return this.data;
        }

        if (this.isLoading && this.pendingPromise) {
            return this.pendingPromise;
        }

        return this.fetchData();
    }

    isValidCache(now) {
        return this.data !== null && (now - this.lastFetchTime) < this.CACHE_DURATION;
    }

    async fetchData() {
        this.isLoading = true;

        this.pendingPromise = this.performRequest();

        try {
            const data = await this.pendingPromise;
            this.data = data;
            this.lastFetchTime = Date.now();
            return data;
        } catch (error) {
            console.error("Erro ao buscar filas:", error);
            throw error;
        } finally {
            this.isLoading = false;
            this.pendingPromise = null;
        }
    }

    async performRequest() {
        const { data } = await api.get("/queue");
        return data;
    }

    invalidate() {
        this.data = null;
        this.lastFetchTime = 0;
        this.isLoading = false;
        this.pendingPromise = null;
    }

    getCacheStatus() {
        const now = Date.now();
        return {
            hasData: this.data !== null,
            isValid: this.isValidCache(now),
            isLoading: this.isLoading,
            timeToExpire: this.isValidCache(now)
                ? this.CACHE_DURATION - (now - this.lastFetchTime)
                : 0
        };
    }
}

const queueCache = new QueueCache();

const useQueues = () => {
    const findAll = async () => {
        try {
            return await queueCache.getData();
        } catch (error) {
            console.error("Erro no useQueues.findAll:", error);
            throw error;
        }
    };

    const invalidateCache = () => {
        queueCache.invalidate();
    };

    const getCacheStatus = () => {
        return queueCache.getCacheStatus();
    };

    const forceRefresh = async () => {
        queueCache.invalidate();
        return await queueCache.getData();
    };

    return {
        findAll,
        invalidateCache,
        getCacheStatus,
        forceRefresh
    };
};

export default useQueues;